<template>
  <div class="lock">
    <section class="right  list list-box" style="margin-top: 20px">
      <div style="height: 20px"></div>
      <div style="display: flex; justify-content: flex-start">
        <el-radio-group v-model="search.type" @input="onTypeChange">
          <el-radio-button label="all">全部设备</el-radio-button>
          <el-radio-button label="free">空闲状态</el-radio-button>
          <el-radio-button label="used">占用状态</el-radio-button>
          <el-radio-button label="exception">故障</el-radio-button>
        </el-radio-group>
        <div style="width: 30px"></div>
        <!-- <el-button
            style="height: 40px; background: #409eff"
            type="primary"
            @click="addOrEdit()"
            >添加</el-button
          > -->
        <!-- <div style="padding:none;margin:none;line-height:38px;width:100px;height:38px;background:#409EFF;text-align: center;color:white;padding-top:-2px;">添加</div>-->
      </div>
     <section>
      <section
        v-if="locks.length>0"
        style="
          width: 100%;
          height: 100%;
          overflow: auto;
          box-sizing: border-box;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          align-content: flex-start;
          padding-top: 0;
        "
      >
        <section
          v-for="item in locks"
          :key="item.id"
          style="
            display: flex;
            justify-content: space-between;
            width: 28%;
            height: 150px;
            border: 1px solid #ddd;
            border-radius: 10px;
            padding: 10px 6px;
            box-sizing: border-box;
            margin: 20px;
            cursor: pointer;
            margin-left: 0;
            margin-bottom: 0;
          "
        >
          <div style="width: 40%">
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div class="battery">
                <canvas
                  :id="item.lockId + '_battery'"
                  width="37"
                  height="23"
                ></canvas>
              </div>
              <div class="signal">
                <img
                  v-if="item.rssi >= -110 && item.rssi < -105"
                  style="width: 40px; height: 20px"
                  src="../../../../assets/images/lock/signal_one.png"
                  alt=""
                />
                <img
                  v-if="item.rssi >= -105 && item.rssi < -100"
                  style="width: 40px; height: 20px"
                  src="../../../../assets/images/lock/signal_two.png"
                  alt=""
                />
                <img
                  v-if="item.rssi >= -100"
                  style="width: 40px; height: 20px"
                  src="../../../../assets/images/lock/signal_four.png"
                  alt=""
                />
              </div>
            </div>

            <div style="position: relative; overflow: hidden">
              <canvas :id="item.lockId + '_type'" width="100" height="100">
              </canvas>
              <!-- <div
                v-if='item.exception !== "正常"'
                  style="font-size:12px;   color:#666;font-weight:500;text-align:center;position:absolute;left:22px;top:60px;"
                >
                  ({{
                    
                    item.exception
                  }})
                </div> -->
            </div>
          </div>

          <div
            style="
              width: 60%;
              border-left: 1px solid #eee;
              padding-left: 10px;
              margin-left: 10px;
              box-sizing: border-box;
            "
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div>
                <span class="lock-item-name"> 锁编号:</span>
                <span class="lock-item-value">{{ item.lockSn }}</span>
              </div>
              <span>
                <!-- <i class="el-icon-delete" @click="del(item.lockId)"></i>
                  <span style="display: inline-block; margin-left: 10px"></span>
                  <i class="el-icon-edit" @click="addOrEdit(item.lockId)"> </i> -->
              </span>
            </div>
            <div style="height: 10px"></div>
            <div>
              <span class="lock-item-name"> 车位号:</span>
              <span class="lock-item-value">{{ item.parkingUniqueId }}</span>
            </div>
            <div style="height: 10px"></div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <span>
                <span class="lock-item-name">收益:</span>
                <span class="lock-item-value">{{ item.total }}元</span>
              </span>
              <!-- <span class="detail">详情</span> -->
            </div>

            <el-divider></el-divider>
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <span style="color: #272727; font-weight: 600">升锁</span>
              <el-switch
                v-model="item.lockStatusType"
                active-color="#37c007"
                inactive-color="#999999"
                active-value="y"
                inactive-value="n"
                @change="changeLockStatus(item)"
              >
              </el-switch>
            </div>
            <div style="height: 10px"></div>
          </div>
        </section>
      </section>
      <div
        v-else
        style="
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <el-empty description="请先选择左侧的停车场"></el-empty>
      </div>
    </section>
    </section>
    <!--添加/修改地磁-->
    <el-dialog
      ref="park"
      title="添加/修改地磁"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="dialogFormVisible"
      width="430px"
      @open="openDialog"
      @close="closeDialog"
      class="dialog-lock"
    >
      <el-form
        :model="editOrAddForm"
        :rules="editOrAddFormRules"
        ref="editOrAddFormV"
      >
        <el-form-item
          label="所属车场"
          :label-width="formLabelWidth"
          prop="devNum"
        >
          <el-col :span="18">
            <el-select v-model="editOrAddForm.parkingId" disabled>
              <el-option
                v-for="item in shareParksData"
                :key="item.parkingId"
                :value="item.parkingId"
                :label="item.parkingName"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item
          label="所属网关"
          :label-width="formLabelWidth"
          prop="devNum"
        >
          <el-col :span="18">
            <el-select v-model="editOrAddForm.gatewayId">
              <el-option
                v-for="item in gateways"
                :key="item.gatewayId"
                :value="item.gatewayId"
                :label="item.gatewaySn"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item
          label="锁编号"
          :label-width="formLabelWidth"
          prop="devNum"
        >
          <el-col :span="18">
            <el-input v-model="editOrAddForm.lockSn"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item
          label="告警声音"
          :label-width="formLabelWidth"
          prop="devNum"
        >
          <el-col :span="18">
            <el-select v-model="editOrAddForm.alarm">
              <el-option
                v-for="[key, value] in Object.entries(lockAlarm)"
                :key="key"
                :value="value"
                :label="value"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item
          label="挡臂阻尼"
          :label-width="formLabelWidth"
          prop="devNum"
        >
          <el-col :span="18">
            <el-select v-model="editOrAddForm.forarmBlock">
              <el-option
                v-for="[key, value] in Object.entries(lockForarmBlock)"
                :key="key"
                :value="value"
                :label="value"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item
          label="发射功率"
          :label-width="formLabelWidth"
          prop="devNum"
        >
          <el-col :span="18">
            <el-select v-model="editOrAddForm.power">
              <el-option
                v-for="[key, value] in Object.entries(lockPower)"
                :key="key"
                :value="value"
                :label="value"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <!-- <el-form-item
            label="升锁设置"
            :label-width="formLabelWidth"
            prop="devNum"
          >
            <el-col :span="18">
              <el-select v-model="editOrAddForm.alarm">
                <el-option
                  v-for="[key, value] in Object.entries(lockTime)"
                  :key="key"
                  :value="key"
                  :label="value"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item> -->
        <!-- <el-form-item
            label="心跳时间"
            :label-width="formLabelWidth"
            prop="devNum"
          >
            <el-col :span="18">
              <el-select v-model="editOrAddForm.alarm">
                <el-option
                  v-for="[key, value] in Object.entries(lockHeartbeat)"
                  :key="key"
                  :value="key"
                  :label="value"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addOrEditTrue">确 定</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  shareLock,
  upLock,
  downLock,
  shareParks,
  gatewaysByParkingId,
  addLock,
  updateLock,
  deleteLock,
  lockDetail,
} from "@/api/url";

import AreaTree from "@/page/commons/parking/commons/areaTree.vue";
const LOCK_ALARM = {
  1: "打开",
  0: "关闭",
};
const LOCK_FORARM_BLOCK = {
  "00": "低",
  "01": "中",
  10: "高",
  11: "最高",
};
const LOCK_POWER = {
  "00": "低",
  "01": "中",
  10: "高",
  11: "最高",
};
const LOCK_TIME = {
  "000": "不自动升",
  "001": "2分钟",
  "010": "5分钟",
  "011": "15分钟",
  100: "30分钟",
  101: "60分钟",
};
const LOCK_HEARTBEAT = {
  "000": "1分钟",
  "001": "5分钟",
  "010": "10分钟",
  "011": "30分钟",
  100: "60分钟",
  101: "2小时",
  110: "3小时",
  111: "4小时",
};
export default {
  props: ["parkingId", "gatewayId"],
  data() {
    return {
      formLabelWidth: "100px",
      lockAlarm: { ...LOCK_ALARM },
      lockForarmBlock: { ...LOCK_FORARM_BLOCK },
      lockPower: { ...LOCK_POWER },
      lockTime: { ...LOCK_TIME },
      lockHeartbeat: { ...LOCK_HEARTBEAT },
      dialogFormVisible: false,
      locks: [],
      search: {
        parkingId: "",
        gatewayId: "",
        type: "all",
      },
      editOrAddForm: {
        parkingId: "",
        gatewayId: "",
        lockSn: "",
        alarm: "",
        forarmBlock: "",
        power: "",
      },
      shareParksData: [],
      gateways: [],
      editOrAddFormRules: [],
    };
  },
  components: {
    AreaTree,
  },
  computed: {
    params() {
      return {
        parkingId: this.parkingId,
        gatewayId: this.gatewayId,
      };
    },
  },
  watch: {
    params: {
      handler(newVal, oldVal) {
        this.locks=[];
        const { parkingId, gatewayId } = newVal;
        console.log("newVal", newVal);
        if (!parkingId) return;
        // if(!gatewayId) return ;
        this.getLocks(parkingId, gatewayId);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    drawType(color, id, text) {
      var canvas = id;
      if (canvas.getContext) {
        canvas.width = canvas.width;
        console.log("canvas.width", canvas.width);
        console.log("canvas.height", canvas.height);
        var ctx = canvas.getContext("2d");
        const radius = 40; // 圆环半径
        // 开始画线
        const textWidth = ctx.measureText(text).width;
        const fix =
          ctx.measureText(text).actualBoundingBoxAscent +
          ctx.measureText(text).actualBoundingBoxDescent;
        ctx.beginPath();
        ctx.font = "16px Arial";
        ctx.textBaseline = "top";
        ctx.fillStyle = "rgba(0, 0, 0, 1)";
        ctx.textAlign = "center"; //文字居中
        ctx.textBaseline = "bottom"; // 文字垂直居中
        ctx.fillText(
          text,
          canvas.width / 2,
          canvas.height / 2 + fix / 2,
          textWidth
        );
        ctx.arc(canvas.width / 2, canvas.height / 2, radius, 0, 2 * Math.PI);
        // 线宽
        ctx.lineWidth = 8;
        // 线的颜色
        ctx.strokeStyle = color;
        ctx.lineJoin = "round"; // 设置线条连接样式为圆角

        // 绘制形状的轮廓。
        ctx.stroke();
      }
    },
    drawBattery(color, id, ratio = 0) {
      var canvas = id;
      if (canvas.getContext) {
        canvas.width = canvas.width;
        var ctx = canvas.getContext("2d");

        // 设置填充颜色
        ctx.fillStyle = color;

        // 圆角矩形的位置和尺寸
        var x = 9;
        var y = 7;
        const r = Number(ratio.replace(/%/g, "")) / 100;
        console.log('ratio.replace(/%/g, ""))', ratio.replace(/%/g, ""));
        console.log("r", r);
        var width = parseInt(30 * r);
        console.log("width", width);
        var height = 20;
        console.log("height", height);
        var radius = 2; // 圆角半径

        // 开始新路径
        ctx.beginPath();

        // 绘制圆角矩形的四个角
        ctx.moveTo(x + radius, y);
        ctx.arcTo(x + width, y, x + width, y + height, radius);
        ctx.arcTo(x + width, y + height, x, y + height, radius);
        ctx.arcTo(x, y + height, x, y, radius);
        ctx.arcTo(x, y, x + width, y, radius);

        // 或者，使用 arc 方法（需要调整角度和中心点）来绘制圆角，但上面的 arcTo 更适合绘制圆角矩形

        // 闭合路径
        ctx.closePath();

        // 填充路径
        ctx.fill();

        // 如果需要边框，可以取消注释以下两行
        // ctx.strokeStyle = "#000000";
        // ctx.stroke();
      }
    },
    getLocks(parkingId, gatewayId) {
      this.$get(`${shareLock()}/${parkingId}`, {
        type: this.search.type,
        gatewayId: gatewayId,
      }).then((res) => {
        if (res?.status != 200) return;
        this.locks = (res?.data ?? []).map((item) => {
          item.lockStatusType = item.lockStatus === "升锁状态" ? "y" : "n";
          return item;
        });
        this.$nextTick(() => {
          (res?.data ?? []).forEach((lock) => {
            console.log(
              "document.getElementById(lock.lockId+'_battery')",
              document.getElementById(lock.lockId + "_battery")
            );
            this.drawBattery(
              "#37c007",
              document.getElementById(lock.lockId + "_battery"),
              lock?.voltage ?? 0
            );
            this.drawType(
              lock.exception !== "正常"
                ? "#999999"
                : lock.parkingSpaceStatus === "空闲"
                ? "#37c007"
                : "#F82810",

              document.getElementById(lock.lockId + "_type"),
              lock.exception !== "正常"
                ? lock.exception
                : lock.parkingSpaceStatus
            );
          });
        });
      });
    },
    //   handleTreeClick: async function (node) {
    //     // 如果节点类型为停车场
    //     if (node.type === "parking") {
    //       this.search.parkingId = node.id;
    //       this.editOrAddForm.parkingId = node.id;
    //       await this.getGateways(this.search.parkingId);
    //       this.search.gatewayId = this.gateways?.[0]?.gatewayId ?? "";
    //       console.log("this.editOrAddForm.parkingId tree click", node.id);
    //       // 获取数据
    //       this.getLocks();
    //     } else {
    //       this.search.parkingId = "";
    //       this.editOrAddForm.parkingId = "";
    //     }
    //   },
    changeLockStatus(item) {
      const { lockId, lockStatusType } = item;
      console.log("lock status type=>", lockStatusType);
      if (lockStatusType === "n") {
        this.$confirm("确定要降锁吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: "降锁中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
            customClass: "loading-lock",
          });
          this.$putRequest(downLock(), {
            lockIds: lockId,
          })
            .then((res) => {
              if (res.status === 200) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getLocks();
              } else {
                this.$message.error(res.message);
              }
            })
            .finally(() => {
              loading.close();
            });
        });
      } else {
        this.$confirm("确定要升锁吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: "升锁中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
            customClass: "loading-lock",
          });
          this.$putRequest(upLock(), {
            lockIds: lockId,
          })
            .then((res) => {
              if (res.status === 200) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getLocks();
              } else {
                this.$message.error(res.message);
              }
            })
            .finally(() => {
              loading.close();
            });
        });
      }
    },
    onTypeChange(value) {
      this.search.type = value;
      this.getLocks(this.parkingId,this.gatewayId);
    },
    addOrEdit(id) {
      if (!this.search.parkingId)
        return this.$message({ type: "error", message: "请先选择停车场" });

      this.dialogFormVisible = true;
      this.editOrAddForm = {
        parkingId: this.search.parkingId,
        lockSn: "",
        alarm: "",
        forarmBlock: "",
        power: "",
      };
      console.log(" add parkingId=>", this.editOrAddForm.parkingId);
      if (id) {
        this.$get(`${lockDetail()}/${id}`).then((data) => {
          if (data.status != 200) return _this.$layer.msg(data.message);
          this.editOrAddForm = data?.data ?? {};
        });
      }
    },
    addOrEditTrue() {
      var _this = this;
      this.$refs["editOrAddFormV"].validate(function (valid, noStri) {
        if (valid) {
          _this.dialogFormVisible = false;
          console.log("_this.addAndEditForm=>", _this.addAndEditForm);
          if (!_this.editOrAddForm.lockId) {
            _this
              .$postRequest(addLock(), {
                ..._this.editOrAddForm,
              })
              .then((data) => {
                if (data.status != 200)
                  return _this.$message.error(data.message);
                _this.$notify({
                  type: "success",
                  message: "添加成功！",
                  title: "成功",
                });
                _this.getLocks();
              });
          } else {
            _this
              .$putRequest(updateLock(), {
                ..._this.editOrAddForm,
              })
              .then((data) => {
                if (data.status !== 200)
                  return _this.$message.error(data.message);
                _this.$notify({
                  type: "success",
                  message: "修改成功！",
                  title: "成功",
                });
                _this.getLocks();
              });
          }
        }
      });
    },
    //   getGateways(id) {
    //     return this.$get(`${gatewaysByParkingId()}/${id}`).then((data) => {
    //       this.gateways = data?.data ?? [];
    //     });
    //   },
    //   getShareParks() {
    //     this.editOrAddForm.gatewayId = "";
    //     this.$postRequest(shareParks(), {}).then((data) => {
    //       this.shareParksData = data?.data?.data?.rows ?? [];
    //     });
    //   },
    del: function (id) {
      var _this = this;

      var index = _this.$layer.confirm(
        "您确定删除该设备吗？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);

          _this.$deleteRequest(`${deleteLock()}/${id}`).then((data) => {
            if (data.status != 200) return _this.$message.error(data.message);

            _this.$notify({
              type: "success",
              message: "删除成功！",
              title: "成功",
            });
            _this.getLocks();
          });
        }
      );
    },
    //   onGatewayChange(value) {
    //     this.search.gatewayId = value;
    //     this.getLocks();
    //   },
    openDialog: function () {},
    closeDialog: function () {
      this.$refs["editOrAddFormV"].resetFields();
    },
  },

  mounted() {
    //   this.getShareParks();
  },
};
</script>
<style scoped>
.battery {
  background: url("../../../../assets/images/lock/battery.png");
  background-position: center;
  background-repeat: no-repeat;
  width: 50px;
  height: 30px;
}
.lock-item-name {
  color: #999;
  font-weight: 500;
  display: inline-block;
  margin-right: 10px;
}
.lock-item-value {
  color: #272727;
  font-weight: 800;
}
.detail {
  display: inline-block;
  background: #f87c10;
  padding: 2px 10px;
  border-radius: 10px;
  color: white;

  font-size: 12px;
}
.el-divider--horizontal {
  margin: 10px 0;
}
.loading-lock {
  font-size: 100px;
}
.list.list-box {
  height: calc(100% - 150px);
}
</style>
